/* eslint-disable max-len */
import { lazy } from 'react';

// project import
import Loadable from '@/from-theme/components/Loadable';
import DashboardLayout from '@/from-theme/layout/Dashboard';
import LocationMaster from '@/pages/masters/location-master/location-master';
import RoleMaster from '@/pages/masters/role-master/role-master';
import ProductMaster from '@/pages/masters/product-master/product-master';
import ClaimMaster from '@/pages/masters/claim-master/claim-master';
import MenuMaster from '@/pages/masters/menu-master/menu-master';
import DropdownMaster from '@/pages/masters/dropdown-master/dropdown-master';
import ZoneMaster from '@/pages/masters/zone-master/zone-master';
import TestMaster from '@/pages/masters/zone-master/zone-master';
import EventMaster from '@/pages/masters/event-master/event-master';
import Settings from '@/pages/masters/settings/settings';
import CustomerMaster from '@/pages/masters/customer-master/customer-master';
import Target from '@/pages/creation/target/target';
import ProtectedRoute from '@/from-theme/utils/route-guard/ProtectedRoute';
import { requestedMenuAll, requestedFeaturesAll } from './constants/menuAccess';
import SchemeStatusMaster from '@/pages/scheme/operations/scheme-status-master/scheme-status-master';
// import CreateEditSchemeMaster from '@/pages/masters/product-master/components/scheme/create-scheme-master/create-scheme-master';
import SchemeNonEligibleApproval from '@/pages/scheme/operations/scheme-non-eligible-approval/scheme-non-eligible-approval';
import CreateEditSchemeNonEligibleApproval from '@/pages/scheme/operations/scheme-non-eligible-approval/pages/create-edit-scheme-non-eligible-approval/create-edit-scheme-non-eligible-approval';
import CreateEditSchemeStatusMaster from '@/pages/scheme/operations/scheme-status-master/pages/create-edit-scheme-status-master/create-scheme-status-master';


// render - dashboard page
const DashboardPage = Loadable(lazy(() => import('pages/dashboard-master/dashboard-page')));
const ActiveUsers = Loadable(lazy(() => import('pages/analytics-dashboard/active-users/active-users')));
const IFoodsDashboardPage = Loadable(lazy(() => import('pages/analytics-dashboard/ifoods-dashboard/ifoods-dashboard')));
// render - master menu page
const EmployeeMaster = Loadable(lazy(() => import('pages/masters/employee-master/employee-master')));
const CreateEditEmployeeMaster = Loadable(lazy(() => import(
  'pages/masters/employee-master/pages/create-edit-employee-master/create-edit-employee-master'
)));
const UserMaster = Loadable(lazy(() => import('pages/masters/user-master/user-master')));
const CreateEditUserMaster = Loadable(lazy(() => import(
  'pages/masters/user-master/pages/create-edit-user-master/create-edit-user-master'
)));
const CompetitorMaster = Loadable(lazy(() => import('pages/masters/ifd-competitor-master/ifd-competitor-master')));
const CreateEditCompetitorMaster = Loadable(lazy(() => import(
  'pages/masters/ifd-competitor-master/pages/create-edit-ifd-competitor-master/create-edit-ifd-competitor-master'
)));
const CompetitorOffers = Loadable(lazy(() => import('pages/masters/competitor-offers/competitor-offers')));
const CreateEditCompetitorOffers = Loadable(lazy(() => import(
  'pages/masters/competitor-offers/pages/create-edit-competitor-offers/create-edit-competitor-offers'
)));
const DivisionMaster = Loadable(lazy(() => import('pages/masters/division-master/division-master')));
const CreateEditDivisionMaster = Loadable(lazy(() => import(
  'pages/masters/division-master/pages/create-edit-division-master/create-edit-division-master'
)));
const CompanyMaster = Loadable(lazy(() => import('pages/masters/company-master/company-master')));
const ClaimLocationCategory = Loadable(lazy(() => import('pages/masters/claim-location-category/claim-location-category')));
const ClaimFrequencyType = Loadable(lazy(() => import('pages/masters/claim-frequency-type/claim-frequency-type')));
const ClaimFrequencyMaster = Loadable(lazy(() => import('pages/masters/claim-frequency-master/claim-frequency-master')));
const ClaimApprovalLevelControl = Loadable(lazy(() => import('pages/masters/regular-claim-approval-control/regular-claim-approval-control')));
const FdCompetitorMaster = Loadable(lazy(() => import('pages/masters/fd-competitor-master/fd-competitor-master')));
const PlanApplicable = Loadable(lazy(() => import('pages/masters/plan-applicable/plan-applicable')));
const VenueMaster = Loadable(lazy(() => import('pages/masters/venue-master/venue-master')));
const BankMaster = Loadable(lazy(() => import('pages/masters/bank-master/bank-master')));
const GlMaster = Loadable(lazy(() => import('pages/masters/gl-master/gl-master')));
const PlantMaster = Loadable(lazy(() => import('pages/masters/plant-master/plant-master')));

const DashboardSlider = Loadable(lazy(() => import('pages/masters/dashboard-slider/dashboard-slider')));
const CreateEditDashboardSlider = Loadable(lazy(() => import(
  'pages/masters/dashboard-slider/pages/create-edit-dashboard-slider/create-edit-dashboard-slider'
)));
const ValidationIprospect = Loadable(lazy(() =>
  import('pages/validation/prospect-validation-ifoods/prospect-validation-ifoods')));
const EditValidationIprospect = Loadable(lazy(() => import(
  'pages/validation/prospect-validation-ifoods/pages/create-edit-validation-ifoods/create-edit-validation-ifoods'
)));
const PlanApprovalManager = Loadable(lazy(() => import('pages/validation/plan-approval-manager/plan-approval-manager')));
const CreateEditPlanApproval = Loadable(lazy(() => import(
  'pages/validation/plan-approval-manager/pages/create-edit-plan-approval/create-edit-plan-approval'
)));
const CreateEditApprovalBo = Loadable(lazy(() => import(
  'pages/validation/approval-plan/pages/create-edit-approval-plan/create-edit-approval-plan'
)));
const PlanDeviationBackoffice = Loadable(lazy(() => import(
  'pages/validation/plan-deviation-approval-backoffice/plan-deviation-approval-backoffice')));
const PlanDeviationBackofficeView = Loadable(lazy(() => import(
  'pages/validation/plan-deviation-approval-backoffice/pages/approval-reject-plan-deviation-backoffice/approval-reject-plan-deviation-backoffice'
)));
const PlanDeviationManager = Loadable(lazy(() => import(
  'pages/validation/plan-deviation-approval-manager/plan-deviation-approval-manager')));
const PlanDeviationManagerView = Loadable(lazy(() => import(
  'pages/validation/plan-deviation-approval-manager/pages/approval-reject-plan-deviation-manager/approval-reject-plan-deviation-manager'
)));
const ApprovalFoods = Loadable(lazy(() => import('pages/validation/approval-foods/approval-foods')));
const CreateEditApprovalFoods = Loadable(lazy(() => import(
  'pages/validation/approval-foods/pages/create-edit-approval-foods/create-edit-approval-foods'
)));
const ApprovalBo = Loadable(lazy(() => import('pages/validation/approval-plan/approval-plan')));
const MenuAccess = Loadable(lazy(() => import('pages/masters/menu-master/components/menuAccess/menuAccess')));
const CreateEditMenuAccess = Loadable(lazy(() => import(
  'pages/masters/menu-master/components/menuAccess/pages/create-edit-menu-access/create-edit-menu-access'
)));
const ApprovalSecondaryCustomer = Loadable(lazy(() => import('pages/validation/secondary-customer-validation/secondary-customer-validation')));
const CreateEditApprovalSecondaryCust = Loadable(lazy(() => import(
  'pages/validation/secondary-customer-validation/pages/create-edit-approval-secondary/create-edit-approval-secondary'
)));
const ApprovalClaimBackoffice = Loadable(lazy(() => import('pages/validation/claim-approval-backoffice/claim-approval-backoffice')));
const CreateEditApprovalClaimBO = Loadable(lazy(() => import(
  'pages/validation/claim-approval-backoffice/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const ApprovalClaimExecutive = Loadable(lazy(() => import('pages/validation/claim-approval-executive/claim-approval-executive')));
const CreateEditApprovalClaimExec = Loadable(lazy(() => import(
  'pages/validation/claim-approval-executive/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const ApprovalClaimManager = Loadable(lazy(() => import('pages/validation/claim-approval-manager/claim-approval-manager')));
const CreateEditApprovalClaimManager = Loadable(lazy(() => import(
  'pages/validation/claim-approval-manager/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const ViewApprovalClaimManager = Loadable(lazy(() => import(
  'pages/validation/claim-approval-manager/pages/create-edit-approve-reject/create-edit-approval-claim'
)));
const RegularApprovalClaimRM = Loadable(lazy(() => import('pages/validation/regular-claim-approval-reporting-manager/regular-claim-approval-reporting-manager')));
const CreateEditRegularApprovalClaimRM = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-reporting-manager/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const RegularApprovalClaimDM = Loadable(lazy(() => import('pages/validation/regular-claim-approval-division-manager/regular-claim-approval-division-manager')));
const ViewRegularApprovalClaimDM = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-division-manager/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const RegularApprovalClaimHR = Loadable(lazy(() => import('pages/validation/regular-claim-approval-hr/regular-claim-approval-hr')));
const ViewRegularApprovalClaimHR = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-hr/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const RegularApprovalClaimExe = Loadable(lazy(() => import('pages/validation/regular-claim-approval-accounts-executive/regular-claim-approval-accounts-executive')));
const ViewRegularApprovalClaimExe = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-accounts-executive/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const RegularApprovalClaimMan = Loadable(lazy(() => import('pages/validation/regular-claim-approval-accounts-manager/regular-claim-approval-accounts-manager')));
const ViewRegularApprovalClaimMan = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-accounts-manager/pages/create-edit-approval-claim/create-edit-approval-claim'
)));
const ClaimSmartForm = Loadable(lazy(() => import(
  'pages/validation/regular-claim-approval-accounts-manager/pages/claim-expense-view/approval-claim-smart-form')));
const CreateEditPlantMaster = Loadable(lazy(() => import(
  'pages/masters/plant-master/pages/create-edit-plant-master/create-edit-plant-master'
)));
const CreateEditVenueMaster = Loadable(lazy(() => import(
  'pages/masters/venue-master/pages/create-edit-venue-master/create-edit-venue-master'
)));
const ProspectMaster = Loadable(lazy(() => import('pages/masters/prospect-master/prospect-master')));
const CreateEditProspectMaster = Loadable(lazy(() => import(
  'pages/masters/prospect-master/pages/create-edit-prospect-master/create-edit-prospect-master'
)));
const ShiftMaster = Loadable(lazy(() => import('pages/masters/shift-master/shift-master')));
const AttendanceReport = Loadable(lazy(() => import('pages/reports/attendance-report/attendance-report')));
const UserReport = Loadable(lazy(() => import('pages/reports/user-report/user-report')));
const AppTrackReport = Loadable(lazy(() => import('pages/reports/app-track-report/app-track-report')));
const MapViewReport = Loadable(lazy(() => import('pages/reports/map-view-report/map-view-report')));
//const MapView = Loadable(lazy(() => import('pages/map/map')));
const TravelReport = Loadable(lazy(() => import('pages/reports/travel-report/travel-report')));
const VenueMappingReport = Loadable(lazy(() => import('pages/reports/venue-mapping-report/venue-mapping-report')));
const TravelClaimReport = Loadable(lazy(() => import('pages/reports/travelling-claim-report/travelling-claim-report')));
const CompetitorReport = Loadable(lazy(() => import('pages/reports/competitor-report/competitor-report')));
const ClaimDetailsReport = Loadable(lazy(() => import('pages/reports/claim-details-report/claim-details-report')));
const ClaimExpenseView = Loadable(lazy(() => import(
  'pages/reports/claim-details-report/pages/claim-expense-view/claim-expense-view')));
const ClaimExpenseReport = Loadable(lazy(() => import('pages/reports/claim-expense-report/claim-expense-report')));
const OutletVisitReport = Loadable(lazy(() => import('pages/reports/outlet-visit-report/outlet-visit-report')));
const ClaimStatusLog = Loadable(lazy(() => import('pages/reports/claim-status-log/claim-status-log')));
const ClaimLog = Loadable(lazy(() => import('pages/reports/claim-status-log/claim-status-log')));
const ClaimExpenseLog = Loadable(lazy(() => import('pages/reports/claim-status-log/claim-status-log')));
const PrimaryCustomerVisitReport = Loadable(lazy(() => import('pages/reports/primary-customer-visit-report/primary-customer-visit-report')));
const SecondaryOutletVisitReport = Loadable(lazy(() => import('pages/reports/secondary-outlet-visit-report/secondary-outlet-visit-report')));
const IfoodsPlanReport = Loadable(lazy(() => import('pages/reports/plan-report/plan-report')));
const PlanDetailsReport = Loadable(lazy(() => import('pages/reports/plan-details-report/plan-details-report')));
const PlanDetailsView = Loadable(lazy(() => import('pages/reports/plan-report/pages/create-edit-view-plan/create-edit-view-plan')));
const PjpReport = Loadable(lazy(() => import('pages/reports/pjp-report/pjp-report')));
const PlanDeviationReport = Loadable(lazy(() => import('pages/reports/plan-deviation-report/plan-deviation-report')));
const IfoodsProspectReport = Loadable(lazy(() => import('pages/reports/prospect-report/prospect-report')));
const MarketPromotionReport = Loadable(lazy(() => import('pages/reports/market-promotion-report/market-promotion-report')));
const PrimaryCustomerReport = Loadable(lazy(() => import('pages/reports/primary-cust-report/primary-customer-report')));
const SecondaryCustomerReport = Loadable(lazy(() => import('pages/reports/second-cust-report/second-cust-report')));
const SecondaryOrderReport = Loadable(lazy(() => import('pages/reports/secondary-order-report/secondary-order-report')));
const PrimaryOrderReport = Loadable(lazy(() => import('pages/reports/primary-order-report/primary-order-report')));
const PrimaryOrderReportView = Loadable(lazy(() =>
  import('pages/reports/primary-order-report/pages/plan-order-view/plan-order-view')));
const CreateEditShiftMaster = Loadable(lazy(() => import(
  'pages/masters/shift-master/pages/create-edit-shift-master/create-edit-shift-master'
)));
const OutletMaster = Loadable(lazy(() => import('pages/masters/outlet-master/outlet-master')));
const CreateEditOutletMaster = Loadable(lazy(() => import(
  'pages/masters/outlet-master/pages/create-edit-outlet-master/create-edit-outlet-master'
)));
const ClaimCreation = Loadable(lazy(() => import('pages/creation/claim-creation/claim-creation')));
const CreateEditClaim = Loadable(lazy(() => import(
  'pages/creation/claim-creation/pages/create-edit-claim-creation/create-edit-claim-creation'
)));
const PlanCreation = Loadable(lazy(() => import('pages/creation/plan-creation/plan-creation')));
const CreateEditPlan = Loadable(lazy(() => import(
  'pages/creation/plan-creation/pages/create-edit-plan-creation/create-edit-plan-creation'
)));
const CalenderEvent = Loadable(lazy(() => import('pages/creation/calendar-event/calendar-event')));
const CreateEditCalenderEvent = Loadable(lazy(() => import(
  'pages/creation/calendar-event/pages/create-edit-calendar-event/create-edit-calendar-event'
)));
const PrimeCustMapping = Loadable(lazy(() => import('pages/masters/primary-material-mapping/primary-material-mapping')));
const CommonNotification = Loadable(lazy(() => import('pages/masters/common-notification/common-notification')));
const CreateEditCommonNotification = Loadable(lazy(() => import(
  'pages/masters/division-master/pages/create-edit-division-master/create-edit-division-master'
)));

//============Sooji QR Bag ========================//
const NewBagRequest = Loadable(lazy(() => import('pages/production/new-bag-request/new-bag-request')));
const CreateEditNewBagRequest = Loadable(lazy(() => import(
  'pages/production/new-bag-request/pages/create-edit-new-bag-request/create-edit-new-bag-request'
)));

const BagRequest = Loadable(lazy(() => import('pages/production/bag-request/bag-request')));
const CreateEditBagRequest = Loadable(lazy(() => import(
  'pages/production/bag-request/pages/create-edit-bag-request/create-edit-bag-request'
)));

const BagIssue = Loadable(lazy(() => import('pages/production/bag-issue/bag-issue')));
const CreateEditBagIssue = Loadable(lazy(() => import(
  'pages/production/bag-issue/components/create-edit-bag-issue/create-edit-bag-issue'
)));

const StoreNewBagRequest = Loadable(lazy(() => import('pages/production/store-new-bag-request/store-new-bag-request')));
const CreateEditStoreNewBagRequest = Loadable(lazy(() => import(
  'pages/production/store-new-bag-request/pages/create-edit-store-new-bag-request/create-edit-store-new-bag-request'
)));

const BagReport = Loadable(lazy(() => import('pages/production/bag-report/bag-report')));
const CreateEditBagReport = Loadable(lazy(() => import(
  'pages/production/bag-report/pages/create-edit-bag-report/create-edit-bag-report'
)));

const QRCodedBagStatusReport = Loadable(lazy(() => import(
  'pages/production/qrcode-bag-status-report/pages/create-edit-qrcode-status-report/create-edit-qrcode-status-report')));

const CreateEditFillBag = Loadable(lazy(() => import(
  'pages/production/fill-bag/manage-fillbag'
)));

const QCRelease = Loadable(lazy(() => import('pages/production/qc-release/qc-release')));
const QCReleaseExceeded = Loadable(lazy(() => import('pages/production/quality-check-exceeded/quality-check-exceeded')));

const CreateEditQCRelease = Loadable(lazy(() => import(
  'pages/production/qc-release/components/create-edit-qc-release/create-edit-qc-release'
)));

const RoastingProcess = Loadable(lazy(() => import('pages/production/roasting-process/roasting-process')));
const CreateEditRoastingProcess = Loadable(lazy(() => import(
  'pages/production/roasting-process/components/create-edit-roasting-process/create-edit-roasting-process'
)));
const RoastingProcessExceeded = Loadable(lazy(() => import('pages/production/roasting-exceeded/roasting-exceeded')));

const FumigationProcess = Loadable(lazy(() => import('pages/production/fumigation-process/fumigation-process')));
const CreateEditFumigationProcess = Loadable(lazy(() => import(
  'pages/production/fumigation-process/components/create-edit-fumigation-process/create-edit-fumigation-process'
)));
const FumigationProcessExceeded = Loadable(lazy(() => import('pages/production/fumigation-exceeded/fumigation-exceeded')));

const QRTransReport = Loadable(lazy(() => import('pages/production/qr-trans-report/qr-trans-report')));
const CreateEditQRTransReportKey = Loadable(lazy(() => import(
  'pages/production/qr-trans-report/pages/create-edit-qr-trans-report/create-edit-qr-trans-report'
)));

/* Foods Scheme */

const SchemeCreation = Loadable(lazy(() => import('pages/scheme/operations/scheme-creation/scheme-creation')));

const CreateEditSchemeCreation = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-creation/pages/create-edit-scheme-creation/create-edit-scheme-creation'
)));

const SchemeCreationApproval = Loadable(lazy(() => import('pages/scheme/operations/scheme-creation-approval/scheme-creation-approval')));

const CreateEditSchemeCreationApproval = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-creation-approval/pages/create-edit-scheme-creation-approval/create-edit-scheme-creation-approval'
)));

const SchemeCreationApprovalCH = Loadable(lazy(() => import('pages/scheme/operations/scheme-creation-approval-ch/scheme-creation-approval-ch')));

const CreateEditSchemeCreationApprovalCH = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-creation-approval-ch/pages/create-edit-scheme-creation-approval-ch/create-edit-scheme-creation-approval-ch'
)));

const SchemeCreationApprovalBH = Loadable(lazy(() => import('pages/scheme/operations/scheme-creation-approval-bh/scheme-creation-approval-bh')));

const CreateEditSchemeCreationApprovalBH = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-creation-approval-bh/pages/create-edit-scheme-creation-approval-bh/create-edit-scheme-creation-approval-bh'
)));

const SchemeGMapproval = Loadable(lazy(() => import('pages/scheme/operations/scheme-gm-approval/scheme-gm-approval')));

const CreateEditSchemeGMApproval = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-gm-approval/pages/create-edit-scheme-gm-approval/create-edit-scheme-gm-approval'
)));

const SchemeCHapproval = Loadable(lazy(() => import('pages/scheme/operations/scheme-ch-approval/scheme-ch-approval')));

const CreateEditSchemeCHapproval = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-ch-approval/pages/create-edit-scheme-ch-approval/create-edit-scheme-ch-approval'
)));

const SchemeAdminEdit = Loadable(lazy(() => import('pages/scheme/operations/scheme-admin-edit/scheme-admin-edit')));

const CreateEditSchemeAdminEdit = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-admin-edit/pages/create-edit-scheme-admin-edit/create-edit-scheme-admin-edit'
)));

const SchemeBHapproval = Loadable(lazy(() => import('pages/scheme/operations/scheme-bh-approval/scheme-bh-approval')));

const CreateEditSchemeBHapproval = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-bh-approval/pages/create-edit-scheme-bh-approval/create-edit-scheme-bh-approval'
)));

const SchemeAHCreditNote = Loadable(lazy(() => import('pages/scheme/operations/scheme-ah-credit-note-approval/scheme-ah-credit-note-approval')));

const CreateEditSchemeAHCreditNote = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-ah-credit-note-approval/pages/create-edit-scheme-ah-credit-note-approval/create-edit-scheme-ah-credit-note-approval'
)));

const SchemeCreditNoteReport = Loadable(lazy(() => import('pages/scheme/operations/scheme-credit-note-report/scheme-credit-note-report')));
const SchemeCustomerWiseReport = Loadable(lazy(() => import('pages/scheme/reports/scheme-customer-wise-report/scheme-customer-wise-report')));
const SchemeCostCenterActualReport = Loadable(lazy(() => import('pages/scheme/reports/scheme-cost-center-actual-report/scheme-cost-center-actual-report')));
const SchemeRejectedCustomerReport = Loadable(lazy(() => import('pages/scheme/reports/scheme-rejected-customer-report/scheme-rejected-customer-report')));

const CreateEditSchemeCreditNoteReport = Loadable(lazy(() => import(
  'pages/scheme/operations/scheme-credit-note-report/pages/create-edit-scheme-credit-note-report/create-edit-scheme-credit-note-report'
)));

const SchemeCostCenterMaster = Loadable(lazy(() => import('pages/scheme/scheme-cost-center-master/SchemeCostCenterMaster')));
const SchemeProductCostCenterMapping = Loadable(lazy(() => import('pages/scheme/scheme-product-cost-center-mapping/SchemeProductCostCenterMapping')));

// Pest Control
const PestControlDailyEntry = Loadable(lazy(() => import('pages/pest-control/daily-entry/daily-entry')));
const PestControlReport = Loadable(lazy(() => import('pages/pest-control/report/report')));
const RodentBoxLocationMaster = Loadable(lazy(() => import('pages/pest-control/rodent-box-location/rodent-box-location')));
const LocationTrapStationMapping = Loadable(lazy(() => import('pages/pest-control/location-trap-station-mapping/location-trap-station-mapping')));
const RodentQRCodeMapping = Loadable(lazy(() => import('pages/pest-control/rodent-qr-code-mapping/rodent-qr-code-mapping')));
const RodentQRCode = Loadable(lazy(() => import('pages/pest-control/rodent-qr-code/rodent-qr-code')));

const {
  companyMasterKey, planValidationKey, approvalFoodsMasterKey, activeUsersDashboardKey,
  approvalClaimBOKey, bankMasterKey, claimMasterKey, travelReportKey, appTrackReportKey,
  ifdCompetitorMasterKey, competitorOffersKey, customerMasterKey, divisionMasterKey, dropdownMasterKey,
  employeeMasterKey, locationMasterKey, menuMasterKey, menuAccessTabMasterKey, secondaryOutletVisitReportKey,
  outletMasterKey, planApplicableMasterKey, planCreationKey, plantMasterKey, claimExpenseReportKey,
  productMasterKey, prospectMasterKey, prospectValidationMasterKey, attendanceReportKey, userReportKey,
  competitorReportKey, prospectReportKey, primeCustReportKey, secondCustReportKey, planDeviationBOKey,
  roleMasterKey, shiftMasterKey, userMasterKey, venueMasterKey, zoneMasterKey, ifoodsPlanReportKey,
  outletVisitReportKey, claimCreationKey, mapViewReportKey, planDeviationReportKey, claimDetailsReportKey,
  travelClaimReportKey, glMasterKey, fdCompetitorMasterKey, secondaryOrderReportKey, venueMappingReportKey,
  primaryCustomerVisitReportKey, pjpReportKey, primaryOrderReportKey, marketPromotionReportKey,
  settingsKey, commonNotificationKey, calendarEventKey, primeMatMappingKey, planValidationManagerKey,
  ifoodsDashboardKey, eventMasterKey, planDeviationManagerKey, approvalClaimManagerKey,
  claimFrequencyMasterKey, claimFrequencyTypeKey, approvalSecCustomerKey, claimLocationCategoryKey, approvalClaimExecKey,
  targetKey, claimStatusLogKey, claimLogKey, claimExpenseLogKey, dashboardSliderKey, regularApprovalClaimRMKey,
  claimApprovalLevelControlKey, regularApprovalClaimDMKey, regularApprovalClaimHRKey, regularApprovalClaimAEKey,
  regularApprovalClaimAMKey, newBagRequestKey, bagRequestKey, bagIssueKey, storeNewBagRequestKey,
  bagReportKey, fillBagKey, qcReleaseKey, qcReleaseExceededKey, roastingProcessKey, roastingProcessExceededKey, fumigationProcessKey, fumigationProcessExceededKey, qrTransReportKey,
  qrcodedBagStatusKey, schemeCreationKey, schemeCreationApprovalKey, schemeCreationApprovalCHKey, schemeCreationApprovalBHKey,
  schemeStatusMasterKey, schemeNonEligibleApprovalMasterKey, schemeGMApprovalKey, schemeCHapprovalKey, schemeAdminEditKey, schemeBHapprovalKey,
  schemeAHcreditnoteApprovalKey, schemeCreditnoteReportKey, schemeCustomerWiseReportKey, schemeCostCenterActualReportKey, schemeRejectedCustomerReportKey, schemeCostCenterMasterKey, schemeProductCostCenterMappingKey,
  pestControlKey, pestControlDailyEntryKey, pestControlReportKey, rodentBoxLocationMasterKey, locationTrapStationMappingKey, rodentQRCodeMappingKey, rodentQRCodeKey } = requestedMenuAll;
const { createKey, readKey, updateKey } = requestedFeaturesAll;

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'dashboard',
          element: <DashboardPage />
        },
        {
          path: 'active-users',
          element: <ProtectedRoute requestedMenu={activeUsersDashboardKey} requestedFeature={readKey} >
            <ActiveUsers />
          </ProtectedRoute>,
        },
        {
          path: 'ifoods-dashboard',
          element: <ProtectedRoute requestedMenu={ifoodsDashboardKey} requestedFeature={readKey} >
            <IFoodsDashboardPage />
          </ProtectedRoute>,
        },
        {
          path: 'company-master',
          element: <ProtectedRoute requestedMenu={companyMasterKey} requestedFeature={readKey} >
            <CompanyMaster />
          </ProtectedRoute>,
        },
        {
          path: 'claim-location-category',
          element: <ProtectedRoute requestedMenu={claimLocationCategoryKey} requestedFeature={readKey} >
            <ClaimLocationCategory />
          </ProtectedRoute>,
        },
        {
          path: 'claim-frequency-type',
          element: <ProtectedRoute requestedMenu={claimFrequencyTypeKey} requestedFeature={readKey} >
            <ClaimFrequencyType />
          </ProtectedRoute>,
        },
        {
          path: 'claim-frequency-master',
          element: <ProtectedRoute requestedMenu={claimFrequencyMasterKey} requestedFeature={readKey} >
            <ClaimFrequencyMaster />
          </ProtectedRoute>,
        },
        {
          path: 'claim-approval-level-control',
          element: <ProtectedRoute requestedMenu={claimApprovalLevelControlKey} requestedFeature={readKey} >
            <ClaimApprovalLevelControl />
          </ProtectedRoute>,
        },
        {
          path: 'fd-competitor-master',
          element: <ProtectedRoute requestedMenu={fdCompetitorMasterKey} requestedFeature={readKey} >
            <FdCompetitorMaster />
          </ProtectedRoute>,
        },
        {
          path: 'bank-master',
          element: <ProtectedRoute requestedMenu={bankMasterKey} requestedFeature={readKey} >
            <BankMaster />
          </ProtectedRoute>,
        },
        {
          path: 'gl-master',
          element: <ProtectedRoute requestedMenu={glMasterKey} requestedFeature={readKey} >
            <GlMaster />
          </ProtectedRoute>,
        },
        {
          path: 'customer-master',
          element: <ProtectedRoute requestedMenu={customerMasterKey} requestedFeature={readKey} >
            <CustomerMaster />
          </ProtectedRoute>,
        },
        {
          path: 'plan-applicable',
          element: <ProtectedRoute requestedMenu={planApplicableMasterKey} requestedFeature={readKey} >
            <PlanApplicable />
          </ProtectedRoute>,
        },
        {
          path: 'competitor-offers',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={competitorOffersKey} requestedFeature={readKey} >
                <CompetitorOffers />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={competitorOffersKey} requestedFeature={createKey} >
                <CreateEditCompetitorOffers />
              </ProtectedRoute>,
            },
            {
              path: "edit/:compProdOffId",
              element: <ProtectedRoute requestedMenu={competitorOffersKey} requestedFeature={updateKey} >
                <CreateEditCompetitorOffers isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'ifd-competitor-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={ifdCompetitorMasterKey} requestedFeature={readKey}>
                <CompetitorMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={ifdCompetitorMasterKey} requestedFeature={createKey}>
                <CreateEditCompetitorMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:competitorId",
              element: <ProtectedRoute requestedMenu={ifdCompetitorMasterKey} requestedFeature={updateKey}>
                <CreateEditCompetitorMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'employee-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={employeeMasterKey} requestedFeature={readKey}>
                <EmployeeMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={employeeMasterKey} requestedFeature={createKey}>
                <CreateEditEmployeeMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:employeeId",
              element: <ProtectedRoute requestedMenu={employeeMasterKey} requestedFeature={updateKey}>
                <CreateEditEmployeeMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'user-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={userMasterKey} requestedFeature={readKey}>
                <UserMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={userMasterKey} requestedFeature={createKey}>
                <CreateEditUserMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:userId",
              element: <ProtectedRoute requestedMenu={userMasterKey} requestedFeature={updateKey}>
                <CreateEditUserMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'division-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={divisionMasterKey} requestedFeature={readKey}>
                <DivisionMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={divisionMasterKey} requestedFeature={createKey}>
                <CreateEditDivisionMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:divisionId",
              element: <ProtectedRoute requestedMenu={divisionMasterKey} requestedFeature={updateKey}>
                <CreateEditDivisionMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'plant-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={plantMasterKey} requestedFeature={readKey}>
                <PlantMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={plantMasterKey} requestedFeature={createKey}>
                <CreateEditPlantMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:plantId",
              element: <ProtectedRoute requestedMenu={plantMasterKey} requestedFeature={updateKey}>
                <CreateEditPlantMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'dashboard-slider',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={dashboardSliderKey} requestedFeature={readKey}>
                <DashboardSlider />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={dashboardSliderKey} requestedFeature={createKey}>
                <CreateEditDashboardSlider />
              </ProtectedRoute>,
            },
            {
              path: "edit/:dasSliderId",
              element: <ProtectedRoute requestedMenu={dashboardSliderKey} requestedFeature={updateKey}>
                <CreateEditDashboardSlider isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'menu-access',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={menuAccessTabMasterKey} requestedFeature={readKey}>
                <MenuAccess />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <>
                <CreateEditMenuAccess />
              </>,
            },
            {
              path: "edit/:menuAccessId",
              element: <ProtectedRoute requestedMenu={menuAccessTabMasterKey} requestedFeature={updateKey}>
                <CreateEditMenuAccess isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'plan-validation',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={planValidationKey} requestedFeature={readKey}>
                <ApprovalBo />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={planValidationKey} requestedFeature={createKey}>
                <CreateEditApprovalBo />
              </ProtectedRoute>,
            },
            {
              path: "edit/:planScheduleId",
              element: <ProtectedRoute requestedMenu={planValidationKey} requestedFeature={updateKey}>
                <CreateEditApprovalBo isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'plan-validation-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={planValidationManagerKey} requestedFeature={readKey}>
                <PlanApprovalManager />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={planValidationManagerKey} requestedFeature={createKey}>
                <CreateEditPlanApproval />
              </ProtectedRoute>,
            },
            {
              path: "edit/:planScheduleId",
              element: <ProtectedRoute requestedMenu={planValidationManagerKey} requestedFeature={updateKey}>
                <CreateEditPlanApproval isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'primary-material-mapping',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={primeMatMappingKey} requestedFeature={readKey}>
                <PrimeCustMapping />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'plan-deviation-approval-backoffice',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={planDeviationBOKey} requestedFeature={readKey}>
                <PlanDeviationBackoffice />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={planDeviationBOKey} requestedFeature={createKey}>
                <PlanDeviationBackofficeView />
              </ProtectedRoute>,
            },
            {
              path: "edit/:planScheduleId",
              element: <ProtectedRoute requestedMenu={planDeviationBOKey} requestedFeature={updateKey}>
                <PlanDeviationBackofficeView isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'plan-deviation-approval-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={planDeviationManagerKey} requestedFeature={readKey}>
                <PlanDeviationManager />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={planDeviationManagerKey} requestedFeature={createKey}>
                <PlanDeviationManagerView />
              </ProtectedRoute>,
            },
            {
              path: "edit/:planScheduleId",
              element: <ProtectedRoute requestedMenu={planDeviationManagerKey} requestedFeature={updateKey}>
                <PlanDeviationManagerView isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'approval-foods',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={approvalFoodsMasterKey} requestedFeature={readKey}>
                <ApprovalFoods />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={approvalFoodsMasterKey} requestedFeature={createKey}>
                <CreateEditApprovalFoods />
              </ProtectedRoute>,
            },
            {
              path: "edit/:planScheduleId",
              element: <ProtectedRoute requestedMenu={approvalFoodsMasterKey} requestedFeature={updateKey}>
                <CreateEditApprovalFoods isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'approval-claim-backoffice',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={approvalClaimBOKey} requestedFeature={readKey}>
                <ApprovalClaimBackoffice />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={approvalClaimBOKey} requestedFeature={createKey}>
                <CreateEditApprovalClaimBO />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={approvalClaimBOKey} requestedFeature={updateKey}>
                <CreateEditApprovalClaimBO isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'approval-claim-executive',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={approvalClaimExecKey} requestedFeature={readKey}>
                <ApprovalClaimExecutive />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={approvalClaimExecKey} requestedFeature={createKey}>
                <CreateEditApprovalClaimExec />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={approvalClaimExecKey} requestedFeature={updateKey}>
                <CreateEditApprovalClaimExec isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'approval-secondary-customer',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={approvalSecCustomerKey} requestedFeature={readKey}>
                <ApprovalSecondaryCustomer />
              </ProtectedRoute>,
            },
            {
              path: "edit/:secondaryCusId",
              element: <ProtectedRoute requestedMenu={approvalSecCustomerKey} requestedFeature={updateKey}>
                <CreateEditApprovalSecondaryCust isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'approval-claim-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={approvalClaimManagerKey} requestedFeature={readKey}>
                <ApprovalClaimManager />
              </ProtectedRoute>,
            },
            {
              path: "edit/",
              element: <ProtectedRoute requestedMenu={approvalClaimManagerKey} requestedFeature={updateKey}>
                <CreateEditApprovalClaimManager isEditMode />
              </ProtectedRoute>,
            },
            {
              path: "view/",
              element: <ProtectedRoute requestedMenu={approvalClaimManagerKey} requestedFeature={updateKey}>
                <ViewApprovalClaimManager isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'regular-approval-claim-reporting-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={regularApprovalClaimRMKey} requestedFeature={readKey}>
                <RegularApprovalClaimRM />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimRMKey} requestedFeature={updateKey}>
                <CreateEditRegularApprovalClaimRM isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'regular-approval-claim-division-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={regularApprovalClaimDMKey} requestedFeature={readKey}>
                <RegularApprovalClaimDM />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimDMKey} requestedFeature={updateKey}>
                <ViewRegularApprovalClaimDM isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'regular-approval-claim-hr',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={regularApprovalClaimHRKey} requestedFeature={readKey}>
                <RegularApprovalClaimHR />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimHRKey} requestedFeature={updateKey}>
                <ViewRegularApprovalClaimHR isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'regular-approval-claim-accounts-executive',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={regularApprovalClaimAEKey} requestedFeature={readKey}>
                <RegularApprovalClaimExe />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimAEKey} requestedFeature={updateKey}>
                <ViewRegularApprovalClaimExe isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'regular-approval-claim-accounts-manager',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={regularApprovalClaimAMKey} requestedFeature={readKey}>
                <RegularApprovalClaimMan />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimAMKey} requestedFeature={updateKey}>
                <ViewRegularApprovalClaimMan isEditMode />
              </ProtectedRoute>,
            },
            {
              path: "view/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={regularApprovalClaimAMKey} requestedFeature={readKey}>
                <ClaimSmartForm />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'prospect-validation',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={prospectValidationMasterKey} requestedFeature={readKey}>
                <ValidationIprospect />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={prospectValidationMasterKey} requestedFeature={createKey}>
                <EditValidationIprospect />
              </ProtectedRoute>,
            },
            {
              path: "edit/:ifProspectId",
              element: <ProtectedRoute requestedMenu={prospectValidationMasterKey} requestedFeature={updateKey}>
                <EditValidationIprospect isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'shift-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={shiftMasterKey} requestedFeature={readKey}>
                <ShiftMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={shiftMasterKey} requestedFeature={createKey}>
                <CreateEditShiftMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={shiftMasterKey} requestedFeature={updateKey}>
                <CreateEditShiftMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'outlet-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={outletMasterKey} requestedFeature={readKey}>
                <OutletMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={outletMasterKey} requestedFeature={createKey}>
                <CreateEditOutletMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:ifOutletId",
              element: <ProtectedRoute requestedMenu={outletMasterKey} requestedFeature={updateKey}>
                <CreateEditOutletMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'prospect-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={prospectMasterKey} requestedFeature={readKey}>
                <ProspectMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={prospectMasterKey} requestedFeature={createKey}>
                <CreateEditProspectMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:ifProspectId",
              element: <ProtectedRoute requestedMenu={prospectMasterKey} requestedFeature={updateKey}>
                <CreateEditProspectMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'claim-creation',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={claimCreationKey} requestedFeature={readKey}>
                <ClaimCreation />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={claimCreationKey} requestedFeature={createKey}>
                <CreateEditClaim />
              </ProtectedRoute>,
            },
            {
              path: "edit/:claimId",
              element: <ProtectedRoute requestedMenu={claimCreationKey} requestedFeature={updateKey}>
                <CreateEditClaim isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'pjp-creation',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={planCreationKey} requestedFeature={readKey}>
                <PlanCreation />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={planCreationKey} requestedFeature={createKey}>
                <CreateEditPlan />
              </ProtectedRoute>,
            },
            {
              path: "edit/:fdPjpId",
              element: <ProtectedRoute requestedMenu={planCreationKey} requestedFeature={updateKey}>
                <CreateEditPlan isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'target',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={targetKey} requestedFeature={readKey}>
                <Target />
              </ProtectedRoute>,
            },

          ]
        },
        {
          path: 'calendar-event',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={calendarEventKey} requestedFeature={readKey}>
                <CalenderEvent />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={calendarEventKey} requestedFeature={createKey}>
                <CreateEditCalenderEvent />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'venue-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={venueMasterKey} requestedFeature={readKey}>
                <VenueMaster />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={venueMasterKey} requestedFeature={createKey}>
                <CreateEditVenueMaster />
              </ProtectedRoute>,
            },
            {
              path: "edit/:userId",
              element: <ProtectedRoute requestedMenu={venueMasterKey} requestedFeature={updateKey}>
                <CreateEditVenueMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'location-master',
          element: <ProtectedRoute requestedMenu={locationMasterKey} requestedFeature={readKey}>
            <LocationMaster />
          </ProtectedRoute>,
        },
        {
          path: 'role-master',
          element: <ProtectedRoute requestedMenu={roleMasterKey} requestedFeature={readKey}>
            <RoleMaster />
          </ProtectedRoute>,
        },
        {
          path: 'menu-master',
          element: <ProtectedRoute requestedMenu={menuMasterKey} requestedFeature={readKey}>
            <MenuMaster />
          </ProtectedRoute>,
        },
        {
          path: 'product-master',
          element: <ProtectedRoute requestedMenu={productMasterKey} requestedFeature={readKey}>
            <ProductMaster />
          </ProtectedRoute>,
        },
        {
          path: 'claim-master',
          element: <ProtectedRoute requestedMenu={claimMasterKey} requestedFeature={readKey}>
            <ClaimMaster />
          </ProtectedRoute>,
        },
        {
          path: 'dropdown-master',
          element: <ProtectedRoute requestedMenu={dropdownMasterKey} requestedFeature={readKey}>
            <DropdownMaster />
          </ProtectedRoute>,
        },
        {
          path: 'event-master',
          element: <ProtectedRoute requestedMenu={eventMasterKey} requestedFeature={readKey}>
            <EventMaster />
          </ProtectedRoute>,
        },
        {
          path: 'zone-master',
          element: <ProtectedRoute requestedMenu={zoneMasterKey} requestedFeature={readKey}>
            <ZoneMaster />
          </ProtectedRoute>,
        },
        {
          path: 'test-master',
          element: <ProtectedRoute requestedMenu={zoneMasterKey} requestedFeature={readKey}>
            <TestMaster />
          </ProtectedRoute>,
        },
        {
          path: 'settings',
          element: <ProtectedRoute requestedMenu={settingsKey} requestedFeature={readKey}>
            <Settings />
          </ProtectedRoute>,
        },
        {
          path: 'attendance-report',
          element: <ProtectedRoute requestedMenu={attendanceReportKey} requestedFeature={readKey}>
            <AttendanceReport />
          </ProtectedRoute>,
        },
        {
          path: 'user-report',
          element: <ProtectedRoute requestedMenu={userReportKey} requestedFeature={readKey}>
            <UserReport />
          </ProtectedRoute>,
        },
        {
          path: 'app-track-report',
          element: <ProtectedRoute requestedMenu={appTrackReportKey} requestedFeature={readKey}>
            <AppTrackReport />
          </ProtectedRoute>,
        },
        {
          path: 'competitor-report',
          element: <ProtectedRoute requestedMenu={competitorReportKey} requestedFeature={readKey}>
            <CompetitorReport />
          </ProtectedRoute>,
        },
        {
          path: 'claim-details-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={claimDetailsReportKey} requestedFeature={readKey}>
                <ClaimDetailsReport />
              </ProtectedRoute>,
            },
            {
              path: "view/:claimSubmissionId",
              element: <ProtectedRoute requestedMenu={claimDetailsReportKey} requestedFeature={readKey}>
                <ClaimExpenseView />
              </ProtectedRoute>,
            }

          ]
        },
        {
          path: 'claim-expense-report',
          element: <ProtectedRoute requestedMenu={claimExpenseReportKey} requestedFeature={readKey}>
            <ClaimExpenseReport />
          </ProtectedRoute>,
        },
        {
          path: 'travel-report',
          element: <ProtectedRoute requestedMenu={travelReportKey} requestedFeature={readKey}>
            <TravelReport />
          </ProtectedRoute>,
        },
        {
          path: 'travel-claim-report',
          element: <ProtectedRoute requestedMenu={travelClaimReportKey} requestedFeature={readKey}>
            <TravelClaimReport />
          </ProtectedRoute>,
        },
        {
          path: 'pjp-report',
          element: <ProtectedRoute requestedMenu={pjpReportKey} requestedFeature={readKey}>
            <PjpReport />
          </ProtectedRoute>,
        },
        {
          path: 'plan-details-report',
          element: <ProtectedRoute requestedMenu={ifoodsPlanReportKey} requestedFeature={readKey}>
            <PlanDetailsReport />
          </ProtectedRoute>,
        },
        {
          path: 'plan-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={ifoodsPlanReportKey} requestedFeature={readKey}>
                <IfoodsPlanReport />
              </ProtectedRoute>,
            },
            {
              path: "view/:planScheduleId",
              element: <ProtectedRoute requestedMenu={ifoodsPlanReportKey} requestedFeature={readKey}>
                <PlanDetailsView />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'plan-deviation-report',
          element: <ProtectedRoute requestedMenu={planDeviationReportKey} requestedFeature={readKey}>
            <PlanDeviationReport />
          </ProtectedRoute>,
        },
        {
          path: 'map-view',
          element: <ProtectedRoute requestedMenu={mapViewReportKey} requestedFeature={readKey}>
            <MapViewReport />
          </ProtectedRoute>,
        },
        // {
        //   path: 'map',
        //   element: <ProtectedRoute requestedMenu={mapViewReportKey} requestedFeature={readKey}>
        //     <MapView />
        //   </ProtectedRoute>,
        // },
        {
          path: 'outlet-visit-report',
          element: <ProtectedRoute requestedMenu={outletVisitReportKey} requestedFeature={readKey}>
            <OutletVisitReport />
          </ProtectedRoute>,
        },
        {
          path: 'claim-status-log',
          element: <ProtectedRoute requestedMenu={claimStatusLogKey} requestedFeature={readKey}>
            <ClaimStatusLog />
          </ProtectedRoute>,
        },
        {
          path: 'claim-log',
          element: <ProtectedRoute requestedMenu={claimLogKey} requestedFeature={readKey}>
            <ClaimLog />
          </ProtectedRoute>,
        },
        {
          path: 'claim-expense-log',
          element: <ProtectedRoute requestedMenu={claimExpenseLogKey} requestedFeature={readKey}>
            <ClaimExpenseLog />
          </ProtectedRoute>,
        },
        {
          path: 'primary-order-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={primaryOrderReportKey} requestedFeature={readKey}>
                <PrimaryOrderReport />
              </ProtectedRoute>,
            },
            {
              path: "view/:primaryOrderId",
              element: <ProtectedRoute requestedMenu={primaryOrderReportKey} requestedFeature={readKey}>
                <PrimaryOrderReportView />
              </ProtectedRoute>,
            },

          ]
        },
        {
          path: 'secondary-order-report',
          element: <ProtectedRoute requestedMenu={secondaryOrderReportKey}
            requestedFeature={readKey}>
            <SecondaryOrderReport />
          </ProtectedRoute>,
        },
        {
          path: 'primary-customer-visit-report',
          element: <ProtectedRoute requestedMenu={primaryCustomerVisitReportKey}
            requestedFeature={readKey}>
            <PrimaryCustomerVisitReport />
          </ProtectedRoute>,
        },
        {
          path: 'secondary-outlet-visit-report',
          element: <ProtectedRoute requestedMenu={secondaryOutletVisitReportKey}
            requestedFeature={readKey}>
            <SecondaryOutletVisitReport />
          </ProtectedRoute>,
        },
        {
          path: 'prospect-report',
          element: <ProtectedRoute requestedMenu={prospectReportKey} requestedFeature={readKey}>
            <IfoodsProspectReport />
          </ProtectedRoute>,
        },
        {
          path: 'market-promotion-report',
          element: <ProtectedRoute requestedMenu={marketPromotionReportKey} requestedFeature={readKey}>
            <MarketPromotionReport />
          </ProtectedRoute>,
        },
        {
          path: 'primary-customer-report',
          element: <ProtectedRoute requestedMenu={primeCustReportKey} requestedFeature={readKey}>
            <PrimaryCustomerReport />
          </ProtectedRoute>,
        },
        {
          path: 'secondary-customer-report',
          element: <ProtectedRoute requestedMenu={secondCustReportKey} requestedFeature={readKey}>
            <SecondaryCustomerReport />
          </ProtectedRoute>,
        },
        {
          path: 'venue-mapping-report',
          element: <ProtectedRoute requestedMenu={venueMappingReportKey} requestedFeature={readKey}>
            <VenueMappingReport />
          </ProtectedRoute>,
        },
        {
          path: 'common-notification',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={commonNotificationKey} requestedFeature={readKey}>
                <CommonNotification />
              </ProtectedRoute>,
            },
            {
              path: "edit/:divisionId",
              element: <ProtectedRoute requestedMenu={commonNotificationKey} requestedFeature={updateKey}>
                <CreateEditCommonNotification isEditMode />
              </ProtectedRoute>,
            }
          ]
        },

        //==================Sooji QR Bag ==============================//

        {
          path: 'new-bag-request',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={newBagRequestKey} requestedFeature={readKey}>
                <NewBagRequest />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={newBagRequestKey} requestedFeature={createKey}>
                <CreateEditNewBagRequest />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={newBagRequestKey} requestedFeature={updateKey}>
                <CreateEditNewBagRequest isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'bag-request',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={bagRequestKey} requestedFeature={readKey}>
                <BagRequest />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={bagRequestKey} requestedFeature={createKey}>
                <CreateEditBagRequest />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={bagRequestKey} requestedFeature={updateKey}>
                <CreateEditBagRequest isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'bag-issue',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={bagIssueKey} requestedFeature={readKey}>
                <BagIssue />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={bagIssueKey} requestedFeature={createKey}>
                <CreateEditBagIssue />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={bagIssueKey} requestedFeature={updateKey}>
                <CreateEditBagIssue isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'store-new-bag-request',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={storeNewBagRequestKey} requestedFeature={readKey}>
                <StoreNewBagRequest />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={storeNewBagRequestKey} requestedFeature={createKey}>
                <CreateEditStoreNewBagRequest />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={storeNewBagRequestKey} requestedFeature={updateKey}>
                <CreateEditStoreNewBagRequest isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'bag-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={bagReportKey} requestedFeature={readKey}>
                <BagReport />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={bagReportKey} requestedFeature={createKey}>
                <CreateEditBagReport />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={bagReportKey} requestedFeature={updateKey}>
                <CreateEditBagReport isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'fill-bag',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={fillBagKey} requestedFeature={readKey}>
                {/* <FillBag /> */}
                <CreateEditFillBag />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={fillBagKey} requestedFeature={createKey}>
                <CreateEditFillBag />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={fillBagKey} requestedFeature={updateKey}>
                <CreateEditFillBag isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'qc-release',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={qcReleaseKey} requestedFeature={readKey}>
                <QCRelease />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={qcReleaseKey} requestedFeature={createKey}>
                <CreateEditQCRelease />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={qcReleaseKey} requestedFeature={updateKey}>
                <CreateEditQCRelease isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'quality-check-exceeded',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={qcReleaseExceededKey} requestedFeature={readKey}>
                <QCReleaseExceeded />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'roasting-process',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={roastingProcessKey} requestedFeature={readKey}>
                <RoastingProcess />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={roastingProcessKey} requestedFeature={createKey}>
                <CreateEditRoastingProcess />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={roastingProcessKey} requestedFeature={updateKey}>
                <CreateEditRoastingProcess isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'roasting-exceeded',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={roastingProcessExceededKey} requestedFeature={readKey}>
                <RoastingProcessExceeded />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'fumigation-process',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={fumigationProcessKey} requestedFeature={readKey}>
                <FumigationProcess />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={fumigationProcessKey} requestedFeature={createKey}>
                <CreateEditFumigationProcess />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={fumigationProcessKey} requestedFeature={updateKey}>
                <CreateEditFumigationProcess isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'fumigation-exceeded',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={fumigationProcessExceededKey} requestedFeature={readKey}>
                <FumigationProcessExceeded />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'qr-trans-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={qrTransReportKey} requestedFeature={readKey}>
                <QRTransReport />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={qrTransReportKey} requestedFeature={createKey}>
                <CreateEditQRTransReportKey />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={qrTransReportKey} requestedFeature={updateKey}>
                <CreateEditQRTransReportKey isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'qr-coded-bag-status-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={qrcodedBagStatusKey} requestedFeature={readKey}>
                {/* <FillBag /> */}
                <QRCodedBagStatusReport />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={qrcodedBagStatusKey} requestedFeature={createKey}>
                <QRCodedBagStatusReport />
              </ProtectedRoute>,
            },
            {
              path: "edit/:bagCount",
              element: <ProtectedRoute requestedMenu={qrcodedBagStatusKey} requestedFeature={updateKey}>
                <QRCodedBagStatusReport isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-creation',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCreationKey} requestedFeature={readKey}>
                <SchemeCreation />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={schemeCreationKey} requestedFeature={createKey}>
                <CreateEditSchemeCreation />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCreationKey} requestedFeature={updateKey}>
                <CreateEditSchemeCreation isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'scheme-creation-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalKey} requestedFeature={readKey}>
                <SchemeCreationApproval />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalKey} requestedFeature={createKey}>
                <CreateEditSchemeCreationApproval />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalKey} requestedFeature={updateKey}>
                <CreateEditSchemeCreationApproval isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'scheme-creation-approval-ch',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalCHKey} requestedFeature={readKey}>
                <SchemeCreationApprovalCH />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalCHKey} requestedFeature={createKey}>
                <CreateEditSchemeCreationApprovalCH />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalCHKey} requestedFeature={updateKey}>
                <CreateEditSchemeCreationApprovalCH isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'scheme-creation-approval-bh',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalBHKey} requestedFeature={readKey}>
                <SchemeCreationApprovalBH />
              </ProtectedRoute>,
            },
            {
              path: "create",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalBHKey} requestedFeature={createKey}>
                <CreateEditSchemeCreationApprovalBH />
              </ProtectedRoute>,
            },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCreationApprovalBHKey} requestedFeature={updateKey}>
                <CreateEditSchemeCreationApprovalBH isEditMode />
              </ProtectedRoute>,
            },
          ]
        },
        {
          path: 'scheme-status-master',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeStatusMasterKey} requestedFeature={readKey}>
                <SchemeStatusMaster />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeStatusMasterKey} requestedFeature={createKey}>
            //     <CreateEditSchemeMaster />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeStatusMasterKey} requestedFeature={updateKey}>
                <CreateEditSchemeStatusMaster isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-non-eligible-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeNonEligibleApprovalMasterKey} requestedFeature={readKey}>
                <SchemeNonEligibleApproval />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeNonEligibleApprovalMasterKey} requestedFeature={updateKey}>
                <CreateEditSchemeNonEligibleApproval isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-gm-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeGMApprovalKey} requestedFeature={readKey}>
                <SchemeGMapproval />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeGMApprovalKey} requestedFeature={updateKey}>
                <CreateEditSchemeGMApproval isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-ch-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCHapprovalKey} requestedFeature={readKey}>
                <SchemeCHapproval />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCHapprovalKey} requestedFeature={updateKey}>
                <CreateEditSchemeCHapproval isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-admin-edit',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeAdminEditKey} requestedFeature={readKey}>
                <SchemeAdminEdit />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeAdminEditKey} requestedFeature={updateKey}>
                <CreateEditSchemeAdminEdit isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-bh-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeBHapprovalKey} requestedFeature={readKey}>
                <SchemeBHapproval />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeBHapprovalKey} requestedFeature={updateKey}>
                <CreateEditSchemeBHapproval isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-ah-credit-note-approval',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeAHcreditnoteApprovalKey} requestedFeature={readKey}>
                <SchemeAHCreditNote />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeAHcreditnoteApprovalKey} requestedFeature={updateKey}>
                <CreateEditSchemeAHCreditNote isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-credit-note-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCreditnoteReportKey} requestedFeature={readKey}>
                <SchemeCreditNoteReport />
              </ProtectedRoute>,
            },
            // {
            //   path: "create",
            //   element: <ProtectedRoute requestedMenu={schemeBudgetApprovalKey} requestedFeature={createKey}>
            //     <CreateEditBudgetMasterApproval />
            //   </ProtectedRoute>,
            // },
            {
              path: "edit/:id",
              element: <ProtectedRoute requestedMenu={schemeCreditnoteReportKey} requestedFeature={updateKey}>
                <CreateEditSchemeCreditNoteReport isEditMode />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-customer-wise-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCustomerWiseReportKey} requestedFeature={readKey}>
                <SchemeCustomerWiseReport />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-cost-center-actual-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeCostCenterActualReportKey} requestedFeature={readKey}>
                <SchemeCostCenterActualReport />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-rejected-customer-report',
          children: [
            {
              index: true,
              element: <ProtectedRoute requestedMenu={schemeRejectedCustomerReportKey} requestedFeature={readKey}>
                <SchemeRejectedCustomerReport />
              </ProtectedRoute>,
            }
          ]
        },
        {
          path: 'scheme-cost-center-master',
          element: <ProtectedRoute requestedMenu={schemeCostCenterMasterKey} requestedFeature={readKey} >
            <SchemeCostCenterMaster />
          </ProtectedRoute>,
        },
        {
          path: 'scheme-product-cost-center-mapping',
          element: <ProtectedRoute requestedMenu={schemeProductCostCenterMappingKey} requestedFeature={readKey} >
            <SchemeProductCostCenterMapping />
          </ProtectedRoute>,
        },
        /* Pest Control Routes */
        {
          path: 'pest-control',
          children: [
            {
              path: 'daily-entry',
              element: <ProtectedRoute requestedMenu={pestControlDailyEntryKey} requestedFeature={readKey}>
                <PestControlDailyEntry />
              </ProtectedRoute>
            },
            {
              path: 'report',
              element: <ProtectedRoute requestedMenu={pestControlReportKey} requestedFeature={readKey}>
                <PestControlReport />
              </ProtectedRoute>
            },
            {
              path: 'rodent-box-location',
              element: <ProtectedRoute requestedMenu={rodentBoxLocationMasterKey} requestedFeature={readKey}>
                <RodentBoxLocationMaster />
              </ProtectedRoute>
            },
            {
              path: 'location-trap-station-mapping',
              element: <ProtectedRoute requestedMenu={locationTrapStationMappingKey} requestedFeature={readKey}>
                <LocationTrapStationMapping />
              </ProtectedRoute>
            },
            {
              path: 'rodent-qr-code',
              element: <ProtectedRoute requestedMenu={rodentQRCodeKey} requestedFeature={readKey}>
                <RodentQRCode />
              </ProtectedRoute>
            },
            {
              path: 'rodent-qr-code-mapping',
              element: <ProtectedRoute requestedMenu={rodentQRCodeMappingKey} requestedFeature={readKey}>
                <RodentQRCodeMapping />
              </ProtectedRoute>
            }
          ]
        },
      ]
    },
  ]
};

export default MainRoutes;
